import { newRelicLogger } from '../logging/new-relic';
import { Translater } from './translater';
import { getTranslationOptions } from './utility';
let _locale;
let _translaterSingleton;
let _translations;
const getCopy = (expectHtml, key, args) => {
    const locale = getLocale();
    const options = getTranslationOptions(locale, expectHtml);
    const translator = getTranslatorSingleton();
    if (translator) {
        return translator.translate(key, locale, args, options) ?? '';
    }
    return '';
};
const getLocale = function () {
    if (_locale) {
        return _locale;
    }
    if (window.OverDrive && window.OverDrive._locale) {
        return window.OverDrive._locale;
    }
    return 'en';
};
const getTranslatorSingleton = () => {
    if (_translaterSingleton) {
        return _translaterSingleton;
    }
    if (window.OverDrive && window.OverDrive.translations) {
        _translaterSingleton = new Translater(window.OverDrive.translations, newRelicLogger, window.OverDrive.tenant);
    }
    return _translaterSingleton;
};
/**
 * Gets a localized version of the copy with HTML encoded (e.g.: `<p>copy text</p>` becomes `&lt;p&gt;copy text&lt;/p&gt;`).
 * @param {string} key The key to find the translation
 * @param {object} args The arguments to use for the template
 */
export const html = (key, args) => {
    return getCopy(true, key, args);
};
/**
 * Sets the current locale and translations for the current session.
 * @param translations The JSON object of translated copy
 * @param locale The current locale
 * @param tenant The current website id
 */
export const setTranslations = (translations, locale, tenant) => {
    _locale = locale;
    if (translations && translations != _translations) {
        _translations = translations;
        _translaterSingleton = new Translater(translations, newRelicLogger, tenant);
    }
};
/**
 * Gets a localized version of the copy with HTML unencoded (e.g.: `<p>copy text</p>` stays `<p>copy text</p>`).
 * @param {string} key The key to find the translation
 * @param {object} args The arguments to use for the template
 */
export const text = (key, args) => {
    return getCopy(false, key, args);
};
